export default __webpack_public_path__ + "static/media/wellness_calendar.84825347.svg";